import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  setChangedShutdownFilter,
  setShutdownFilterSearchValue,
  setVisibleShutdownFilter,
} from '../model/actions';
import { useSelector } from 'react-redux';
import { selectFilterChanged } from '../model/selectors';
import { fetchShutdownsThunk } from '../../../shared/model/actions';

const SubmitFilter = ({ render, ...props }) => {
  const dispatch = useDispatch();

  const filterChanged = useSelector(selectFilterChanged);

  const onSubmit = useCallback(async () => {
    dispatch(setVisibleShutdownFilter(false));
    dispatch(setChangedShutdownFilter(false));
    dispatch(setShutdownFilterSearchValue(''));

    await dispatch(fetchShutdownsThunk());
  }, [dispatch]);

  return render({ onSubmit, disabled: !filterChanged, ...props });
};

export default SubmitFilter;
